<template>
  <div class="topUpForm">
    <transition name="loadShadow">
      <div class="loadShadow" v-show="loading">
        <i class="loadgif"></i>
      </div>
    </transition>
    <div class="topUpMain">
      <i class="closeOrganization" @click="closeTopUp"></i>
      <div class="pointCenter">
        <div>
          <p class="pointTitle">当前余额</p>
          <div class="pointLine">
            <p class="pointLabel">下载次数:</p>
            <input type="number" readonly class="leftoverTimes" v-model="leftoverDownload">
          </div>
          <div class="pointLine">
            <p class="pointLabel">刷新次数:</p>
            <input type="number" readonly class="leftoverTimes" v-model="leftoverRefresh">
          </div>
        </div>
        <div>
          <p class="pointTitle">新增</p>
          <div class="pointLine">
            <p class="pointLabel">下载次数:</p>
            <input type="number" readonly class="leftoverTimes" v-model="topUpDownload">
          </div>
          <div class="pointLine">
            <p class="pointLabel">刷新次数:</p>
            <input type="number" readonly class="leftoverTimes" v-model="topUpRefresh">
          </div>
        </div>
        <!---->
        <div class="topUpPackage">
          <p class="pointTitle">选择套餐</p>
          <div class="packageList">
            <span @click="choiceTopUp(item)" class="package_item" :class="{'activeTopUp': selectedTopUpType === item.label}" v-for="(item, index) in topUpType" :key="index">{{item.label}}</span>
          </div>
        </div>

        <button type="button" class="topUpButton" @click="topUpWarn">充值</button>
      </div>
    </div>
  </div>
</template>
<script>
import xz from "../../common";
export default {
  props: {
    entid: {
      type: String,
      default: ""
    }
  },
  data(){
    return {
      loading: false,
      // 剩余下载次数
      leftoverDownload: 0,
      // 剩余刷新次数
      leftoverRefresh: 0,
      // 新增下载次数
      topUpDownload: 0,
      // 新增刷新次数
      topUpRefresh: 0,
      // 选择的套餐
      selectedTopUpType: "",
      topUpType: [{
        value: 100,
        type: "all",
        label: "100全"
      },{
        value: 200,
        type: "all",
        label: "200全"
      },{
        value: 300,
        type: "all",
        label: "300全"
      },{
        value: 500,
        type: "all",
        label: "500全"
      },{
        value: 800,
        type: "all",
        label: "800全"
      },{
        value: 1000,
        type: "all",
        label: "1000全"
      },{
        value: 100,
        type: "download",
        label: "100下载"
      },{
        value: 100,
        type: "refresh",
        label: "100刷新"
      },{
        value: 200,
        type: "download",
        label: "200下载"
      },{
        value: 200,
        type: "refresh",
        label: "200刷新"
      },{
        value: 500,
        type: "download",
        label: "500下载"
      },{
        value: 500,
        type: "refresh",
        label: "500刷新"
      }]
    }
  },
  created(){

  },
  watch: {
    "entid": {
      handler: function(){
        if(this.entid){
          this.getPoints(this.entid);
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取企业的点
    getPoints(entid){
      this.loading = true;
      xz.leftoverPoints(entid).then(points => {
        this.loading = false;
        if(points){
          this.leftoverDownload = points.IntDownload;
          this.leftoverRefresh = points.IntRefesh;
        }
      })
    },
    // 关闭充值页面
    closeTopUp(){
      this.$emit("cancel");
    },
    // 选择套餐
    choiceTopUp(type){
      this.selectedTopUpType = type.label;
      if(type.type === "refresh"){
        this.topUpDownload = 0;
        this.topUpRefresh = type.value;
      }else if(type.type === "download"){
        this.topUpDownload = type.value;
        this.topUpRefresh = 0;
      }else{
        this.topUpDownload = type.value;
        this.topUpRefresh = type.value;
      }
    },
    // 充值提示
    topUpWarn(){
      this.$confirm(`确认充值套餐: 刷新数:${this.topUpRefresh}次, 下载数:${this.topUpDownload}次`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.topUpNumber();
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消充值'
          });          
        });
    },

    // 充值
    topUpNumber(){
      if(!this.selectedTopUpType){
        this.$message({
          message: '请选择套餐类型',
          type: 'warning'
        });
        return;
      }
      this.loading = true;
      xz.topUpCompany(
        this.entid,
        {
        operinfo: {
          intfresh: this.topUpRefresh,
          intdownload: this.topUpDownload
        }
      }).then( success => {
        this.$message({
            type: success ? 'success' : 'error',
            message: success ? '充值成功!' : '充值失败'
          });
        if(success){
          this.getPoints(this.entid);
          this.topUpDownload = 0;
          this.topUpRefresh = 0;
          this.selectedTopUpType = "";
        }else{
          this.loading = false;
        }
      });
    }
  }
}
</script>
<style scoped>
.topUpForm{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.topUpMain{
  width: 500px;
  box-sizing: border-box;
  padding: 40px 40px;
  border-radius: 5px;
  position: relative;
  background: #fff;
}
.pointCenter{
  width: 100%;
}
.pointLine{
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  box-sizing: border-box;
  padding: 0 20px;
}
.pointLabel{
  width: 100px;
  font-size: 14px;
}
.pointLine input{
  border: 1px solid #ddd;
  border-radius: 5px;
  outline: none;
  width: 150px;
  padding: 5px 10px;
  font-size: 14px;
  height: 40px;
  box-sizing: border-box;
  cursor: pointer;
}
.pointTitle{
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}
.topUpPackage{
  width: 100%;
  border-top: 1px solid #ddd;
  margin-top: 20px;
  padding-top: 20px;
}
.packageList{
  width: 100%;
}
.packageList span{
  display: inline-block;
  padding: 8px 15px;
  color: #333;
  font-size: 14px;
  border-radius: 5%;
  border: 1px solid #DCDFE6;
  cursor: pointer;
  margin: 0 15px 15px 0;
}
.topUpButton{
  width: 150px;
  border: none;
  font-size: 14px;
  height: 40px;
  color: #fff;
  outline: none;
  background: #409eff;
  border-radius: 5px;
  display: block;
  margin: 20px auto 0 auto;
}
.activeTopUp{
  background: #409eff !important;
  border: 1px solid #409eff !important;
  color: #fff !important;
}
</style>